import React from 'react';
import {Header} from 'semantic-ui-react';

// import IconButton from 'material-ui/IconButton';
import FlatButton from 'material-ui/FlatButton';
import ActionGrade from 'material-ui/svg-icons/action/grade';
import ActionHelp from 'material-ui/svg-icons/action/help';

import logo from '../../assets/icons/chatedio-horizontal-icon.png';
import './styles.css';

export class ChatedHeader extends React.Component {
	render() {
		if (this.props.compact) {
			return (
				<Header size="large" className="chated-header-compact">
					<div id="user-link">
						<FlatButton
							href="https://chated.io?utm_source=portal.chated.io/#contact"
							label="Contact Support"
							icon={<ActionHelp />}
						/>
						<FlatButton
							target="_blank"
							href="https://apps.shopify.com/abandoned-cart-recovery-1?reveal_new_review=true&utm_source=portal.chated.io"
							label="Rate Us"
							icon={<ActionGrade />}
						/>
					</div>
					<div id="logo-wrapper" className="compact">
						<img src={logo} alt="chated.io" height="42px" width="131px" />
					</div>
				</Header>
			);
		}
		return (
			<Header size="large" className="chated-header">
				<div id="logo-wrapper" className="compact">
					<img className="ui centered image" src={logo} alt="chated.io" height="42px" width="131px" />
				</div>
			</Header>
		);
	}
}

export default ChatedHeader;



// WEBPACK FOOTER //
// ./src/components/chated-header/index.js